import { data } from "jquery";
import { ApiUrl } from "../../config/apiConfig";
import { uploadpdf } from "../Axios/Axios";
import { Dispatch } from "react";
import messageService from "../message/messageService";
import moment from "moment";
import dayjs from "dayjs";

const removeEmptyFields = (obj: any): any => {
  let newObj: any = {};
  Object.keys(obj).forEach((key) => {
    console.log(key);
    if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
      newObj[key] = removeEmptyFields(obj[key]);
      console.log(newObj[key], "newObj[key] >>>>>>>");
    } else if (Array.isArray(obj[key])) {
      newObj[key] = obj[key].filter((item: any) => item);
      console.log(newObj[key], " newObj[key]>>>>>>");
    } else if (obj[key] !== "") {
      newObj[key] = obj[key];
      console.log(newObj[key], " newObj[key]>>>>>>");
    }
  });
  return newObj;
};

const cleanObject = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = { ...obj };
  Object.keys(cleanedObj).forEach((key) => {
    if (
      cleanedObj[key] &&
      typeof cleanedObj[key] === "object" &&
      !Array.isArray(cleanedObj[key])
    ) {
      cleanedObj[key] = cleanObject(cleanedObj[key]);
    } else if (cleanedObj[key] === undefined || cleanedObj[key] === "") {
      delete cleanedObj[key];
    } else if (Array.isArray(cleanedObj[key])) {
      cleanedObj[key] = cleanedObj[key].filter(
        (item: any) => item !== undefined && item !== ""
      );
      if (cleanedObj[key].length === 0) {
        cleanedObj[key] = [{}];
      }
    }
  });
  return cleanedObj;
};

const cleanObject2 = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = { ...obj };

  Object.keys(cleanedObj).forEach((key) => {
    if (key === "others") {
      cleanedObj[key] = cleanedObj[key].map((item: any) => {
        if (typeof item === "object") {
          item.other_file = item.other_file.map((file: any) => {
            // Ensure each file is a string
            return typeof file === 'string' ? file : '';
          });
          return cleanObject(item);
        }
        return item;
      });
    } else if (
      cleanedObj[key] &&
      typeof cleanedObj[key] === "object" &&
      !Array.isArray(cleanedObj[key])
    ) {
      cleanedObj[key] = cleanObject(cleanedObj[key]);
      if (Object.keys(cleanedObj[key]).length === 0) {
        delete cleanedObj[key];
      }
    } else if (cleanedObj[key] === undefined || cleanedObj[key] === "") {
      if (key !== "others") {
        delete cleanedObj[key];
      }
    } else if (Array.isArray(cleanedObj[key])) {
      cleanedObj[key] = cleanedObj[key]
        .map((item: any) => {
          if (typeof item === "object") {
            // Ensure array elements are strings or clean objects
            if (item.hasOwnProperty('other_file')) {
              item.other_file = item.other_file.map((fileItem: any) => {
                return typeof fileItem === 'string' ? fileItem : '';
              });
            }
            return cleanObject(item);
          }
          return item;
        })
        .filter((item: any) => {
          if (typeof item === "object" && key !== "others") {
            return Object.keys(item).length > 0;
          }
          return item !== undefined && item !== "";
        });

      if (cleanedObj[key].length === 0 && key !== "others") {
        delete cleanedObj[key];
      }
    }
  });

  return cleanedObj;
};




const cleanObjectcarrrier = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = { ...obj };

  Object.keys(cleanedObj).forEach((key) => {
    if (key === "others") {
      cleanedObj[key] = cleanedObj[key].map((item: any) => {
        if (typeof item === "object") {
          return cleanObject2(item); // Use cleanObject2 instead of cleanObject
        }
        return item;
      });
    } else if (
      cleanedObj[key] &&
      typeof cleanedObj[key] === "object" &&
      !Array.isArray(cleanedObj[key])
    ) {
      cleanedObj[key] = cleanObject2(cleanedObj[key]);
      if (Object.keys(cleanedObj[key]).length === 0) {
        delete cleanedObj[key];
      }
    } else if (cleanedObj[key] === undefined || cleanedObj[key] === "") {
      if (key !== "others") {
        delete cleanedObj[key];
      }
    } else if (Array.isArray(cleanedObj[key])) {
      cleanedObj[key] = cleanedObj[key]
        .map((item: any) => {
          if (typeof item === "object") {
            return cleanObject2(item); // Use cleanObject2 instead of cleanObject
          }
          return item;
        })
        .filter((item: any) => {
          if (typeof item === "object" && key !== "others") {
            return Object.keys(item).length > 0;
          }
          return item !== undefined && item !== "";
        });

      if (cleanedObj[key].length === 0 && key !== "others") {
        delete cleanedObj[key];
      }
    }

    // Ensure specific fields are strings
    if ([
      "mc_letter_expiry_date", "tax_form_issue_date", "tax_form_expiry_date", 
      "insurance_issue_date", "insurance_expiry_date", "others[0].other_issue_date", 
      "others[0].other_expiry_date", "others[0].other_file[0]"
    ].includes(key)) {
      cleanedObj[key] = String(cleanedObj[key]);
    }
  });

  return cleanedObj;
};


const cleanFormData = (formData: any) => {
  let cleanedFormData = { ...formData };

  Object.keys(cleanedFormData).forEach((key) => {
    if (!cleanedFormData[key]) {
      delete cleanedFormData[key];
    }
  });

  return cleanedFormData;
};


const cleanFormDatadocument = (formData: any) => {
  let cleanedFormData = { ...formData };
  Object.keys(cleanedFormData).forEach((key) => {
    if (!cleanedFormData[key]) {
      delete cleanedFormData[key];
    }
  });
  Object.keys(cleanedFormData).forEach((key) => {
    if (Array.isArray(cleanedFormData[key])) {
      if (key === 'others') {
        // Remove objects with empty other_file arrays
        cleanedFormData[key] = cleanedFormData[key].filter((other: any) => 
          Array.isArray(other.other_file) && other.other_file.length > 0
        );
      } else if (cleanedFormData[key].length === 0) {
        // Preserve non-empty arrays (if applicable)
        return;
      }
    } else if (typeof cleanedFormData[key] === 'object') {
      // Recursively clean objects
      cleanedFormData[key] = cleanFormData(cleanedFormData[key]);
      // Remove empty objects
      if (Object.keys(cleanedFormData[key]).length === 0) {
        delete cleanedFormData[key];
        return;
      }
    } else if (cleanedFormData[key] === '' || cleanedFormData[key] === null) {
      // For required fields, make sure they are preserved
      if (['company_id', 'trailer_id', 'registration_issue_date', 'registration_expiry_date', 'insurance_card_issue_date', 'insurance_card_expiry_date'].includes(key)) {
        // Keep required fields even if empty
        return;
      }
      // Remove other empty values
      delete cleanedFormData[key];
    }
  });

  return cleanedFormData;
};







const cleanFormDataskip = (formData: { skip_number: any }) => {
  let cleanedFormData: any = {};

  if ("skip_number" in formData) {
    cleanedFormData.skip_number = formData.skip_number;
  }

  return cleanedFormData;
};

const handleDateChange = (
  date: any,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError?: React.Dispatch<React.SetStateAction<any>> // setError is now optional

) => {
  console.log(date, "setFormData3setFormData3setFormData3");
  const formattedDate = date
    ? date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
    : "";
  setFormData((prevState: any) => ({
    ...prevState,
    [field]: formattedDate,
  }));

  if (setError) {
    setError((prevError: any) => ({
      ...prevError,
      [field]: formattedDate ? "" : prevError[field],
    }));
  }

  console.log(formattedDate, "setFormData3setFormData3setFormData3");

};

const handleDateChangefiltr = (
  date: any,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  console.log(date, field, setFormData, "setFormData3setFormData3setFormData3");
  const formattedDate = date ? date.toISOString() : ""; // Use toISOString for ISO 8601 format
  setFormData((prevState: any) => ({
    ...prevState,
    [field]: formattedDate,
  }));
};

const handleDateChange1 = (
  date: Date | null,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  if (date) {
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    console.log(formattedDate, "formattedDateformattedDateformattedDate");
    setFormData((prevState: any) => {
      const newState = { ...prevState };
      if (field.includes(".")) {
        const path = field.split(".");
        let currentLevel = newState;
        for (let i = 0; i < path.length - 1; i++) {
          const key = path[i];
          if (!currentLevel[key]) {
            currentLevel[key] = isNaN(Number(path[i + 1])) ? {} : [];
          }
          currentLevel = currentLevel[key];
        }
        currentLevel[path[path.length - 1]] = formattedDate;
      } else {
        newState[field] = formattedDate;
      }
      return newState;
    });
  }
};

const handleDateChangeMillisecond = (
  date: Date | null,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  if (date) {
    const formattedDate = String(new Date(date).getTime());
    console.log(formattedDate, "formattedDateformattedDateformattedDate");
    setFormData((prevState: any) => {
      const newState = { ...prevState };
      if (field.includes(".")) {
        const path = field.split(".");
        let currentLevel = newState;
        for (let i = 0; i < path.length - 1; i++) {
          const key = path[i];
          if (!currentLevel[key]) {
            currentLevel[key] = isNaN(Number(path[i + 1])) ? {} : [];
          }
          currentLevel = currentLevel[key];
        }
        currentLevel[path[path.length - 1]] = formattedDate;
      } else {
        newState[field] = formattedDate;
      }
      return newState;
    });
  }
};

const handleChange = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  console.log(setError, "setErrorsetErrorsetError");
  const { name, value } = event.target;
  console.log(name, "namenamenamenamename");

  const path = name.split(".");
  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });
  // setError((prevError: any) => ({ ...prevError, [name]: "" }));

  setError((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = "";
    console.log("Updated errors:", newError);
    return newError;
  });
};

const handleChange1 = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  console.log("name:", name);

  const path = name.split(".");

  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  console.log("Updating error for name:", name);

  setError((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = "";
    console.log("Updated errors:", newError);
    return newError;
  });
};

const handleChange1_notes = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setNotesAndAttachments: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  console.log("name:", name);

  const path = name.split(".");

  setNotesAndAttachments((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  console.log("Updating error for name:", name);

  setError((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = "";
    console.log("Updated errors:", newError);
    return newError;
  });
};

const handleChangeFormArray = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  const path = name.split(".");

  setFormData((prevState: any) => {
    const newState = { ...prevState };

    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];

      if (!isNaN(Number(key))) {
        currentLevel = currentLevel[key] = currentLevel[key] || [];
        if (i === path.length - 2) {
          currentLevel[key] = currentLevel[key] || {};
        }
      } else {
        currentLevel = currentLevel[key] = currentLevel[key] || {};
      }
    }

    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  setError((prevError: any) => ({ ...prevError, [name]: "" }));
};

const handleChangeFormArraytwo = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  const path = name.split(".");

  setFormData((prevState: any) => {
    const newState = { ...prevState };

    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];

      if (!isNaN(Number(key))) {
        const index = Number(key);
        if (!currentLevel[index]) {
          currentLevel[index] = {};
        }
        currentLevel = currentLevel[index];
      } else {
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        }
        currentLevel = currentLevel[key];
      }
    }

    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  setError((prevError: any) => ({ ...prevError, [name]: "" }));
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "unset !importent",
   

    padding: "0",
    border: "none",
    width: "1000px",
    overflowY: "auto" as "auto",
  },
};

const CleanFormDataSpecial = (formData: any) => {
  let cleanedFormData = { ...formData };

  const cleanObject = (obj: any) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === "object") {
        cleanObject(obj[key]);
      } else if (!obj[key]) {
        delete obj[key];
      }
    });
  };

  cleanObject(cleanedFormData.payment_type);
  cleanObject(cleanedFormData.invoice_method);

  if (Array.isArray(cleanedFormData.invoice_setting)) {
    cleanedFormData.invoice_setting = cleanedFormData.invoice_setting
      .map((item: any) => {
        let cleanedItem = { ...item };
        cleanObject(cleanedItem);
        return cleanedItem;
      })
      .filter((item: {}) => Object.keys(item).length > 0);
  }

  if (Array.isArray(cleanedFormData.status_info)) {
    cleanedFormData.status_info = cleanedFormData.status_info
      .map((item: any) => {
        let cleanedItem = { ...item };
        cleanObject(cleanedItem);
        return cleanedItem;
      })
      .filter((item: {}) => Object.keys(item).length > 0);
  }

  return cleanedFormData;
};

const handleChange_Radiosingle_button = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFormData: React.Dispatch<React.SetStateAction<FormData>>,
  setError?: React.Dispatch<React.SetStateAction<Record<string, string>>>
) => {
  const { name, value } = event.target;
  console.log(name, value, " namevalue ");

  setFormData((prevState) => {
    const newState = { ...prevState };
    const path = name.split(".");

    // Update nested data structure
    let currentLevel = newState as any;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;

    return newState;
  });

  // Optional error handling (if provided)
  if (setError) {
    setError((prevError) => ({ ...prevError, [name]: "" }));
  }
};

const cleanObject3 = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (Array.isArray(value)) {
      const cleanedArray = value
        .map((item) => (typeof item === "object" ? cleanObject2(item) : item))
        .filter(
          (item) =>
            !(item === undefined || item === "") &&
            (typeof item !== "object" || Object.keys(item).length > 0)
        );

      if (cleanedArray.length > 0) {
        cleanedObj[key] = cleanedArray;
      }
    } else if (value && typeof value === "object") {
      const cleanedValue = cleanObject2(value);
      if (Object.keys(cleanedValue).length > 0) {
        cleanedObj[key] = cleanedValue;
      }
    } else if (value !== undefined && value !== "") {
      cleanedObj[key] = value;
    }
  });

  return cleanedObj;
};

const cleanObject_drop_drog = (
  obj: Record<string, any>
): Record<string, any> => {
  const cleanedObj: Record<string, any> = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (Array.isArray(value)) {
      const cleanedArray = value
        .map((item) => (typeof item === "object" ? cleanObject3(item) : item))
        .filter(
          (item) =>
            item !== undefined &&
            item !== "" &&
            (typeof item !== "object" || Object.keys(item).length > 0)
        );

      if (cleanedArray.length > 0) {
        cleanedObj[key] = cleanedArray;
      }
    } else if (value && typeof value === "object") {
      const cleanedValue = cleanObject3(value);
      if (Object.keys(cleanedValue).length > 0) {
        cleanedObj[key] = cleanedValue;
      }
    } else if (value !== undefined && value !== "") {
      cleanedObj[key] = value;
    }
  });

  return cleanedObj;
};

const handleDateChangeArray = (
  date: Date | null,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  if (date) {
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setFormData((prevState: any) => {
      const newState = { ...prevState };

      if (field.includes(".")) {
        const path = field.split(".");
        let currentLevel = newState;

        for (let i = 0; i < path.length - 1; i++) {
          if (!currentLevel[path[i]]) currentLevel[path[i]] = {};
          currentLevel = currentLevel[path[i]];
        }
        currentLevel[path[path.length - 1]] = formattedDate;
      } else {
        newState[field] = formattedDate;
      }

      return newState;
    });
  }
};
const pickup_informationd = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  const path = name.split(".");
  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];
      if (!currentLevel[key]) {
        currentLevel[key] = isNaN(Number(path[i + 1])) ? {} : [];
      }
      currentLevel = currentLevel[key];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });
};

const cleanObjectall = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (Array.isArray(value)) {
      const cleanedArray = value
        .map((item) => (typeof item === "object" ? cleanObject3(item) : item))
        .filter(
          (item) =>
            item !== undefined &&
            item !== "" &&
            (typeof item !== "object" || Object.keys(item).length > 0)
        );

      if (cleanedArray.length > 0) {
        cleanedObj[key] = cleanedArray;
      }
    } else if (value && typeof value === "object") {
      const cleanedValue = cleanObject3(value);
      if (Object.keys(cleanedValue).length > 0) {
        cleanedObj[key] = cleanedValue;
      }
    } else if (value !== undefined && value !== "") {
      cleanedObj[key] = value;
    }
  });

  return cleanedObj;
};

const tenderhandleChange = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  settender: React.Dispatch<React.SetStateAction<any>>,
  setError1: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  const path = name.split(".");
  settender((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });
  setError1((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = "";
    console.log("Updated errors1:", newError);
    return newError;
  });
};

const tenderhandleChangef = (
  event: React.ChangeEvent<
    HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  >,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const { name, value } = event.target;
  const path = name.split(".");

  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  setError((prevError: any) => ({ ...prevError, [name]: "" }));
};

const handleDateChange4 = (
  date: Date | null,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  if (date) {
    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    console.log(formattedDate, "formattedDateformattedDateformattedDate");
    setFormData((prevState: any) => {
      const newState = { ...prevState };
      if (field.includes(".")) {
        const path = field.split(".");
        let currentLevel = newState;
        for (let i = 0; i < path.length - 1; i++) {
          const key = path[i];
          if (!currentLevel[key]) {
            currentLevel[key] = isNaN(Number(path[i + 1])) ? {} : [];
          }
          currentLevel = currentLevel[key];
        }
        currentLevel[path[path.length - 1]] = formattedDate;
      } else {
        newState[field] = formattedDate;
      }
      return newState;
    });
  }
};

const cleanObjecth = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = { ...obj };

  Object.keys(cleanedObj).forEach((key) => {
    if (Array.isArray(cleanedObj[key])) {
      cleanedObj[key] = cleanedObj[key]
        .map((item: any) => {
          if (typeof item === "object") {
            return cleanObject(item);
          }
          return item;
        })
        .filter((item: any) => {
          if (typeof item === "object") {
            return Object.keys(item).length > 0;
          }
          return item !== undefined && item !== "";
        });

      if (cleanedObj[key].length === 0) {
        delete cleanedObj[key];
      }
    } else if (cleanedObj[key] && typeof cleanedObj[key] === "object") {
      cleanedObj[key] = cleanObject(cleanedObj[key]);
      if (Object.keys(cleanedObj[key]).length === 0) {
        delete cleanedObj[key];
      }
    } else if (cleanedObj[key] === undefined || cleanedObj[key] === "") {
      delete cleanedObj[key];
    }
  });

  return cleanedObj;
};
const formatValueWithDollarSign = (value: string): string => {
  const numericValue = value.replace(/^\$|\$/g, "");

  if (isNaN(parseFloat(numericValue))) {
    return "";
  }

  const formattedValue = `$${parseFloat(numericValue)}`;
  return formattedValue;
};

const removeDollarSign = (value: string): string => {
  return value.replace(/^\$|\$/g, "");
};

const selectImage = (
  event: { target: { files: any[] } },
  fileType: string,
  setFormData: Dispatch<any>
) => {
  console.log(event, fileType, "fileTypefileType");
  if (event.target.files && event.target.files[0]) {
    const obj = {
      file: event.target.files[0],
    };
    uploadImages(obj, fileType, setFormData);
  }
};

const uploadImages = async (obj: any, fileType: any, setFormData: any) => {
  console.log(obj, fileType, "fileTypefileTypffffe");
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf:", response.original);
    const messageServicesd = messageService();
    messageServicesd.toast("success", "Pdf has been upload successfully");
    updateStateService({ [fileType]: response.original }, setFormData);
  } catch (error) {
    console.error("Error posting data:", error);
  }
};

const updateStateService = (
  data: { [x: number]: any },
  setFormData: (arg0: (prev: any) => any) => void
) => {
  console.log(data, "setFormData");
  setFormData((prev: any) => ({ ...prev, ...data }));
};

const handleButtonClick = (inputId: string) => {
  console.log(inputId, "inputId");
  const fileInput = document.getElementById(inputId);
  if (fileInput) {
    fileInput.click();
  }
};

const handleButtonClickArray = (inputId: string, index: number) => {
  const uniqueInputId = `${inputId}_${index}`;
  console.log(uniqueInputId, "uniqueInputId");
  const fileInput = document.getElementById(uniqueInputId) as HTMLInputElement;
  if (fileInput) {
    fileInput.click();
  }
};

const selectImageArray = (
  event: { target: { files: any[] } },
  fileType: string,
  index: number,
  field: string,
  setFormData: Dispatch<any>
) => {
  console.log(event, fileType, "fileTypefileType");
  if (event.target.files && event.target.files[0]) {
    const obj = {
      file: event.target.files[0],
    };
    uploadImagesArray(obj, fileType, index, field, setFormData);
  }
};

const uploadImagesArray = async (
  obj: any,
  fileType: any,
  index: number,
  field: string,
  setFormData: any
) => {
  console.log(obj, fileType, "fileTypefileTypffffe");
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf:", response.original);
    updateStateServiceArray(
      { [`${fileType}.${index}.${field}`]: response.original },
      setFormData
    );
  } catch (error) {
    console.error("Error posting data:", error);
  }
};

const updateStateServiceArray = (
  data: { [key: string]: any },
  setFormData: (arg0: (prev: any) => any) => void
) => {
  console.log(data, "setFormDatadddd");
  setFormData((prevState: any) => {
    const newState = { ...prevState };
    const [key, index, field] = Object.keys(data)[0].split(".");
    console.log(key, index, field, "ggggg");

    if (!newState[key] || !Array.isArray(newState[key])) {
      newState[key] = [];
    }

    if (!newState[key][index]) {
      newState[key][index] = {};
    }

    newState[key][index][field] = data[Object.keys(data)[0]];
    return newState;
  });
};

const handleButtonClickArrays = (inputId: string, index: number) => {
  const uniqueInputId = `${inputId}_${index}`;
  console.log(uniqueInputId, "uniqueInputId");
  const fileInput = document.getElementById(uniqueInputId) as HTMLInputElement;
  console.log(fileInput, "fileInputfileInput");
  if (fileInput) {
    fileInput.click();
  }
};

const selectImageArrays = (
  event: React.ChangeEvent<HTMLInputElement>,
  fileType: string,
  index: number,
  field: string,
  setFormData: Dispatch<any>
) => {
  if (event.target.files && event.target.files[0]) {
    const obj = {
      file: event.target.files[0],
    };
    uploadImagesArrays(obj, fileType, index, field, setFormData);
  }
};

const uploadImagesArrays = async (
  obj: any,
  fileType: any,
  index: number,
  field: string,
  setFormData: any
) => {
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf response:", response);
    updateStateServiceArrays(
      response.original,
      fileType,
      index,
      field,
      setFormData
    );
  } catch (error) {
    console.error("Error posting data:", error);
  }
};

const updateStateServiceArrays = (
  fileURL: string,
  fileType: string,
  index: number,
  field: string,
  setFormData: Dispatch<any>
) => {
  setFormData((prevState: any) => {
    const newState = { ...prevState };

    if (!newState[fileType] || !Array.isArray(newState[fileType])) {
      newState[fileType] = [];
    }

    newState[fileType][index] = fileURL;
    return newState;
  });
};

const handleRemoveFileS = (
  index: number,
  fileType: string,
  setFormData: Dispatch<any>
) => {
  setFormData((prev: any) => {
    const newState = { ...prev };
    if (newState[fileType] && newState[fileType][index]) {
      newState[fileType][index] = null;
    }
    return newState;
  });
};

const handleDateChangefilter = (
  date: Date | null, // Type date as Date or null
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  if (!date) {
    // Handle case where no date is selected
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: null, // Set the field to null if no date is selected
    }));
    return;
  }

  // Format the date in ISO 8601 format using a library like moment.js or native methods
  const formattedDate = formatDateToISO8601(date);

  setFormData((prevState: any) => ({
    ...prevState,
    [field]: formattedDate,
  }));
};

function formatDateToISO8601(date: Date): string {
  // Use moment.js if available (simpler formatting)
  if (moment) {
    return moment(date).format(); // Or a specific ISO 8601 format string
  }

  // Use native methods for broader compatibility
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// @mk
const handlephonenumberinput = () => {
  console.log("handle phone input");
};

const fetchCityAndState = async (zipCode: any, index: any) => {
  console.log(zipCode, index, "zipCodezipCodezipCodezipCode");
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=AIzaSyClA8iSH4aGdDXaxUj6HGIoS4bXFHkOqwQ`
    );
    const data = await response.json();
    console.log(data, "datadatadatadatannnnn");
    if (data.results && data.results.length > 0) {
      const addressComponents = data.results[0].address_components;
      let city = "";
      let state = "";

      addressComponents.forEach(
        (component: { types: any; long_name: string; short_name: string }) => {
          const types = component.types;
          if (types.includes("locality")) {
            city = component.long_name;
          } else if (types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
        }
      );

      return { city, state };
    }
  } catch (error) {
    console.error("Error fetching city and state:", error);
  }
  return { city: "", state: "" };
};

const fetchZipCodeAndState = async (city: string, index: number) => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${city}&key=AIzaSyClA8iSH4aGdDXaxUj6HGIoS4bXFHkOqwQ`
    );
    const data = await response.json();
    console.log(data, "data");

    if (data.results && data.results.length > 0) {
      const addressComponents = data.results[0].address_components;
      let zipCode = "";
      let state = "";

      addressComponents.forEach(
        (component: { types: any; long_name: string; short_name: string }) => {
          const types = component.types;
          if (types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
        }
      );

      return { zipCode, state, index };
    }
  } catch (error) {
    console.error("Error fetching ZIP code and state:", error);
  }
  return { zipCode: "", state: "", index };
};

const fetchZipCodeAndCity = async (state: string, index: number) => {
  try {
    const apiKey = "AIzaSyClA8iSH4aGdDXaxUj6HGIoS4bXFHkOqwQ";
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${state}&key=${apiKey}`
    );
    const data = await response.json();
    console.log(data, "data");

    if (data.results && data.results.length > 0) {
      const addressComponents = data.results[0].address_components;
      let city = "";
      let zipCode = "";

      addressComponents.forEach(
        (component: { types: string[]; long_name: string }) => {
          const types = component.types;
          if (types.includes("locality")) {
            city = component.long_name;
          } else if (types.includes("postal_code")) {
            zipCode = component.long_name;
          }
        }
      );

      return { city, zipCode, index };
    }
  } catch (error) {
    console.error("Error fetching city and ZIP code:", error);
  }
  return { city: "", zipCode: "", index };
};

const select_Image_Array_ssingle_button = (
  event: React.ChangeEvent<HTMLInputElement>,
  fileType: string,
  index: number,
  setFormData: Dispatch<any>,
  setFileIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  console.log(fileType, "fileType");

  if (event.target.files && event.target.files.length > 0) {
    const files = Array.from(event.target.files);
    console.log(files, "filesfilesfilesfilesfiles");

    files.forEach((file) => {
      const obj = { file };
      console.log(obj, "objobjobjobjobj");
      uploadImagesArraysd(obj, fileType, index, setFormData);
    });
  }
  setFileIndex((prevIndex: number) => prevIndex + 1);
};

const handle_Button_ClickArrays_single_button = (
  inputId: string,
  index?: number
) => {
  console.log(inputId,"inputIdinputIdidnputId")
  const uniqueInputId = inputId;
  console.log(uniqueInputId, "uniqueInputIduniqueInputId");
  const fileInput = document.getElementById(uniqueInputId) as HTMLInputElement;
  console.log(fileInput, "fileInputfileInputfileInput");
  if (fileInput) {
    fileInput.click();
  }
};


const handle_Button_ClickArrays_single_button_carrer = (
  inputId: string,
  index?: number
) => {
  console.log(inputId,"inputIdinputIdidnputId")
  const uniqueInputId = inputId;
  console.log(uniqueInputId, "uniqueInputIduniqueInputId");
  const fileInput = document.getElementById(uniqueInputId) as HTMLInputElement;
  console.log(fileInput, "fileInputfileInputfileInput");
  if (fileInput) {
    fileInput.click();
  }
};





const handle_Remove_FileS_singlr_button = (
  index: number,
  fileType: string,
  setFormData: Dispatch<any>
) => {
  setFormData((prev: any) => {
    const newState = { ...prev };
    if (newState[fileType] && newState[fileType][index]) {
      URL.revokeObjectURL(newState[fileType][index]);
      newState[fileType].splice(index, 1);
    }
    return newState;
  });
};

const uploadImagesArraysd = async (
  obj: any,
  fileType: string,
  index: number,
  setFormData: (value: ((prevState: any) => any) | any) => void
) => {
  console.log(fileType, "fileTypeficccleType");
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf response:", response);

    if (response && response.original) {
      setFormData((prev: any) => {
        const newState = { ...prev };
        if (!newState[fileType]) {
          newState[fileType] = [];
        }
        newState[fileType][index] = response.original;
        return newState;
      });
    }
    if (response) {
      console.log(response.original, "responseresponsekkkk");
      setFormData((prev: any) => {
        const newState = { ...prev };
        console.log(fileType, "fileTypfileTypee");
        if (!newState[fileType]) {
          newState[fileType] = [];
        }
        newState[fileType][index] = response.original;
        return newState;
      });
    } else {
      console.error("Invalid response structure:", response);
    }
  } catch (error) {
    console.error("Error posting data:", error);
  }
};

const select_Image_Array_single_button = (
  event: React.ChangeEvent<HTMLInputElement>,
  fileType: string,
  index: number,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setFileIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  if (event.target.files && event.target.files.length > 0) {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      const obj = { file };
      uploadImagesArray2(obj, fileType, index, setFormData);
    });
  }
  setFileIndex((prevIndex: number) => prevIndex + 1);
};


const select_Image_Array_single_button_LOAD = (
  event: React.ChangeEvent<HTMLInputElement>,
  fileType: string,
  index: number,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setFileIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  if (event.target.files && event.target.files.length > 0) {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      const obj = { file };
      uploadImagesArray2_load(obj, fileType, index, setFormData);
    });
  }
  setFileIndex((prevIndex: number) => prevIndex + 1);
};





const handle_Button_Click_Array_single_button = (inputId: string) => {
  const fileInput = document.getElementById(inputId) as HTMLInputElement;
  if (fileInput) {
    fileInput.click();
  }
};

const handle_Remove_File_single_button = (
  index: number,
  fileType: string,
  fileIndex: number,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  setFormData((prev: any) => {
    const newState = { ...prev };
    if (newState.others && newState.others[index][fileType]) {
      URL.revokeObjectURL(newState.others[index][fileType][fileIndex]);
      newState.others[index][fileType].splice(fileIndex, 1);
    }
    return newState;
  });
};

const uploadImagesArray2 = async (
  obj: any,
  fileType: string,
  index: number,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf response:", response);
    if (response && response.original) {
      setFormData((prev: any) => {
        const newState = { ...prev };
        if (!newState.others[index][fileType]) {
          newState.others[index][fileType] = [];
        }
        newState.others[index][fileType].push(response.original);
        return newState;
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};



const uploadImagesArray2_load = async (
  obj: any,
  fileType: string,
  index: number,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    console.log("uploadpdf response:", response);

    if (response && response.original) {
      setFormData((prev: any) => {
        // Create a copy of the previous state
        const newState = { ...prev };
        
        // Ensure addOthers is an array
        if (!Array.isArray(newState.addOthers)) {
          newState.addOthers = [];
        }

        // Ensure index is within bounds and initialize it if necessary
        if (index >= newState.addOthers.length) {
          // Fill with empty objects if index is out of bounds
          newState.addOthers.length = index + 1;
        }
        if (!newState.addOthers[index]) {
          newState.addOthers[index] = {};
        }

        // Ensure fileType key exists
        if (!newState.addOthers[index][fileType]) {
          newState.addOthers[index][fileType] = [];
        }

        // Add the uploaded file to the array
        newState.addOthers[index][fileType].push(response.original);

        return newState;
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};



const select_Image_Array_ssingle_button1 = (
  event: React.ChangeEvent<HTMLInputElement>,
  fileType: string,
  index: number,
  setFormData: Dispatch<any>,
  setFileIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  if (event.target.files && event.target.files.length > 0) {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      const obj = { file, fileType };
      uploadImagesArraysd1(obj, fileType, index, setFormData);
    });
  }
  setFileIndex((prevIndex: number) => prevIndex + 1);
};

const uploadImagesArraysd1 = async (
  obj: any,
  fileType: string,
  index: number,
  setFormData: (value: ((prevState: any) => any) | any) => void
) => {
  try {
    const response = await uploadpdf(ApiUrl.fileUpload, obj);
    if (response && response.original) {
      setFormData((prev: any) => {
        const newState = { ...prev };
        if (!newState.Attachment) {
          newState.Attachment = [];
        }
        newState.Attachment[index] = {
          file_type: fileType,
          file: response.original,
        };
        return newState;
      });
    } else {
      console.error("Invalid response structure:", response);
    }
  } catch (error) {
    console.error("Error posting data:", error);
  }
};

const cleancarriar = (formData: any) => {
  // Create a deep copy of the formData to avoid mutating the original state
  let cleanedFormData = JSON.parse(JSON.stringify(formData));

  // Helper function to remove empty fields and ensure specific formats
  const removeEmptyFields = (obj: any) => {
    Object.keys(obj).forEach((key) => {
      if (Array.isArray(obj[key])) {
        // Filter out objects with empty key or value
        obj[key] = obj[key].filter((item: any) => {
          if (typeof item === "object" && item !== null) {
            return (item.key && item.value) || false;
          }
          return item !== "";
        });
        // Remove the array if it becomes empty
        if (obj[key].length === 0) {
          delete obj[key];
        }
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        removeEmptyFields(obj[key]);
      } else if (obj[key] === "" || obj[key] === null) {
        delete obj[key];
      }
    });
  };

  removeEmptyFields(cleanedFormData);

  // Ensure phone_number is an array of strings
  if (Array.isArray(cleanedFormData.phone_number)) {
    cleanedFormData.phone_number = cleanedFormData.phone_number.map(
      (item: any) => (typeof item === "string" ? item : "")
    );
  }

  // Ensure that specific fields are not empty
  if (Array.isArray(cleanedFormData.information_add_more)) {
    cleanedFormData.information_add_more =
      cleanedFormData.information_add_more.filter(
        (item: any) => item.key && item.value
      );
  }

  if (Array.isArray(cleanedFormData.dispacter_add_more)) {
    cleanedFormData.dispacter_add_more =
      cleanedFormData.dispacter_add_more.filter(
        (item: any) => item.key && item.value
      );
  }

  if (Array.isArray(cleanedFormData.permits_add_more)) {
    cleanedFormData.permits_add_more = cleanedFormData.permits_add_more.filter(
      (item: any) =>
        item.key &&
        item.value &&
        !isNaN(new Date(item.permits_add_more_expiry).getTime())
    );
  }

  return cleanedFormData;
};

const handleDateChangeNumber = (
  date: any,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError?:any
) => {
  console.log(date, "setFormData3setFormData3setFormData3");


  if (date) {
    const daeddte = new Date(date);
    const milliseconds = daeddte.getTime();
    console.log(milliseconds, "millisecondsmillisecondsmilliseconds");
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: milliseconds,
    }));
  } else {
    console.warn("Received null date");
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: 0,
    }));
  }

  
  setError((prevError: any) => {
    const { [field]: _, ...rest } = prevError; // Remove the error for the current field
    console.log("Updated errors:", rest);
    return rest; // Return the updated error object without the error for the current field
  });

};





const cleanObjectcarrridoecument = (obj: Record<string, any>): Record<string, any> => {
  const cleanedObj: Record<string, any> = { ...obj };

  Object.keys(cleanedObj).forEach((key) => {
    if (key === "others") {
      cleanedObj[key] = cleanedObj[key].map((item: any) => {
        if (typeof item === "object") {
          return cleanObject2(item); // Use cleanObject2 instead of cleanObject
        }
        return item;
      });
    } else if (
      cleanedObj[key] &&
      typeof cleanedObj[key] === "object" &&
      !Array.isArray(cleanedObj[key])
    ) {
      cleanedObj[key] = cleanObject2(cleanedObj[key]);
      if (Object.keys(cleanedObj[key]).length === 0) {
        delete cleanedObj[key];
      }
    } else if (cleanedObj[key] === undefined || cleanedObj[key] === "") {
      if (key !== "others") {
        delete cleanedObj[key];
      }
    } else if (Array.isArray(cleanedObj[key])) {
      cleanedObj[key] = cleanedObj[key]
        .map((item: any) => {
          if (typeof item === "object") {
            return cleanObject2(item); // Use cleanObject2 instead of cleanObject
          }
          return item;
        })
        .filter((item: any) => {
          if (typeof item === "object" && key !== "others") {
            return Object.keys(item).length > 0;
          }
          return item !== undefined && item !== "";
        });

      if (cleanedObj[key].length === 0 && key !== "others") {
        delete cleanedObj[key];
      }
    } else if (
      ["mc_letter_expiry_date", "tax_form_issue_date", "tax_form_expiry_date", "insurance_issue_date", "insurance_expiry_date"].includes(key)
    ) {
      // Handle undefined or empty values for date fields
      cleanedObj[key] = cleanedObj[key] || 0; // Or set to null if preferred
    }
  });

  return cleanedObj;
};




const areDatesEqual = (date1: Date, date2: Date): boolean => {
  return date1.getTime() === date2.getTime();
};


const formatPhoneNumberd = (phoneNumber: string) => {
  const cleaned = phoneNumber.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }

  return phoneNumber;
};

const preventSpecialCharacters = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const regex = /^[a-zA-Z0-9\s]*$/;

  const key = String.fromCharCode(e.keyCode || e.which);

  if (!regex.test(key) && e.key !== 'Backspace') {
    e.preventDefault();
  }
};


const handleDateChangeK_Number = (
  date: any,
  field: string,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError?: React.Dispatch<React.SetStateAction<any>>
) => {
  console.log(date, "Date Received");

  const isValidDate = dayjs(date).isValid();
  const dateInMilliseconds = isValidDate ? dayjs(date).valueOf() : null;

  setFormData((prevState: any) => ({
    ...prevState,
    [field]: dateInMilliseconds,
  }));

  if (setError) {
    setError((prevError: any) => ({
      ...prevError,
      [field]: dateInMilliseconds ? "" : prevError[field],
    }));
  }

  console.log(dateInMilliseconds, "Formatted Date");
};


const handleChange_dolor = (
  value: string | undefined, 
  name: string,  
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  console.log("name:", name);

  const path = name.split(".");

 
  const formattedValue = value ? `$${value}` : '';  

  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value || '';  
    return newState;
  });

  console.log("Updating error for name:", name);

  setError((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = ""; // Clear error if any
    console.log("Updated errors:", newError);
    return newError;
  });

  // Return the formatted value for display purposes
  return formattedValue;
};

export {
  handlephonenumberinput,
  handleDateChange4,
  tenderhandleChangef,
  removeEmptyFields,
  cleanObject,
  cleanObject2,
  cleanFormData,
  handleDateChange,
  handleDateChange1,
  handleChange,
  customStyles,
  CleanFormDataSpecial,
  handleChange_Radiosingle_button,
  cleanObject3,
  handleChangeFormArray,
  handleDateChangeArray,
  pickup_informationd,
  handleChangeFormArraytwo,
  cleanObjectall,
  tenderhandleChange,
  handleDateChangeMillisecond,
  cleanObjecth,
  formatValueWithDollarSign,
  removeDollarSign,
  cleanFormDataskip,
  selectImage,
  handleButtonClick,
  handleButtonClickArray,
  selectImageArray,
  selectImageArrays,
  handleButtonClickArrays,
  handleRemoveFileS,
  fetchCityAndState,
  fetchZipCodeAndState,
  fetchZipCodeAndCity,
  select_Image_Array_ssingle_button,
  handle_Button_ClickArrays_single_button,
  handle_Remove_FileS_singlr_button,
  select_Image_Array_single_button,
  handle_Remove_File_single_button,
  handle_Button_Click_Array_single_button,
  handleChange1,
  cleanObject_drop_drog,
  select_Image_Array_ssingle_button1,
  handleChange1_notes,
  cleancarriar,
  handleDateChangeNumber,
  cleanObjectcarrrier,
  cleanObjectcarrridoecument,
  cleanFormDatadocument,
  select_Image_Array_single_button_LOAD,
  handle_Button_ClickArrays_single_button_carrer,
  areDatesEqual,
  formatPhoneNumberd,
  preventSpecialCharacters,
  handleDateChangeK_Number,
  handleChange_dolor
};
